import { Component, Input } from '@angular/core';

@Component({
    selector: 'loader-button-spinner',
    templateUrl: './loader-button-spinner.component.html',
    standalone: false
})
export class LoaderButtonSpinnerComponent {
	@Input() isShowButtonSpinner: boolean = false;
}
